// src/components/DocPartPlanALL.js
import React, { useEffect, useState, useRef } from "react";
import styles from "../../styles/AutoDocumentService/GovtLetter.module.css";
import CroppedMapImage from "./CroppedMapImage";
import logo1 from "../../assets/image/top-left.png";
import s1 from "../../assets/image/s1.png";
import l1 from "../../assets/image/legend1.png";

const DocPartPlan = ({ name, address, date, proposalId, survey, village, signPath }) => {
  const [croppedImage, setCroppedImage] = useState(null);
  const [signBase64, setSignBase64] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const prevVillageRef = useRef(village);


  // Convert image URL to base64
  const toBase64 = async (url) => {
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error("Failed to fetch image");
      const blob = await res.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Base64 conversion error:", error);
      return null;
    }
  };


  // Load signature
  useEffect(() => {
    const loadSignature = async () => {
      if (!signPath) return;
      const base64Img = await toBase64(
        `${process.env.REACT_APP_SERVER_URL}/proxy_image.php?path=${signPath}`
      );
      if (base64Img) setSignBase64(base64Img);
    };
    loadSignature();
  }, [signPath]);

  // Reset loading and cropped image when village changes
  // useEffect(() => {
  //   if (prevVillageRef.current !== village) {
  //     setIsLoading(true);
  //     setCroppedImage(null);
  //     prevVillageRef.current = village;
  //   }
  // }, [village]);


  useEffect(() => {
    if (prevVillageRef.current !== village) {
      console.log(`Village changed from ${prevVillageRef.current} to ${village}`);
      setIsLoading(true);
      setCroppedImage(null);
      setErrorMsg(""); // Reset error
      prevVillageRef.current = village;

      // Force a slight delay to ensure state updates
      setTimeout(() => {
        // This ensures the CroppedMapImage gets fresh props
      }, 100);
    }
  }, [village]);
  // Mark loading complete once map is ready
  useEffect(() => {
    if (croppedImage) setIsLoading(false);
  }, [croppedImage]);

  // Document Data
  const documentData = {
    header: {
      logo: logo1,
      govtText: [
        "महाराष्ट्र शासन",
        "नगर रचना आणि मूल्यनिर्धारण विभाग,",
        "सांगली मिरज आणि कुपवाङ शहर महानगरपालिका.",
        "शहर पोलीस ठाण्यासमोर, राजवाडा चौक. सांगली, महाराष्ट्र - ४१६ ४१६.",
      ],
      contactInfo: {
        email: "Email ID : smkcorporation@gmail.com",
        phone: "दुरध्वनी क्र.  0233-2373721",
      },
      reference: {
        leftText: "    ",
        rightText: `दि. ${date}`,
      },
    },
    recipient: {
      title: "प्रति,",
      name: `Shri/Smt. ${name},`,
      address,
    },
    subject: {
      title: "विषयः-",
      text: `सांगली मिरज आणि कुपवाड शहर महानगरपालिका क्षेत्राच्या ३० (१) अन्वये शासनास मंजुरीसाठी सादर केलेल्या प्रारूप प्रसिद्ध विकास योजनेच्या भाग नकाशा ची प्रत मिळणेबाबत.`,
    },
    reference: {
      title: "संदर्भः-",
      text: `आपला दि.${date} रोजीचा Online अर्ज. (Proposal ID : ${proposalId})`,
    },
    body: {
      salutation: "महाशय,",
      content: `&nbsp; &nbsp; &nbsp; &nbsp; सांगली मिरज आणि कुपवाड शहर महानगरपालिका क्षेत्राची प्रारूप प्रसिद्ध विकास योजना महानगरपालिका महारष्ट्र प्रादेशिक व नगररचना अधिनियम, १९६६ चे कलम ३१ (१) अन्वये शा सनास में जुरीसाठी सादर केली आहे. त्या नकाशानुसार जंगलीवाडी येथील ${survey} भूमापन क्रमांक/ नगर भूमापन क्रमांक या जागेचा भाग नकाशा सोबत जोडलेला आहे.`,
    },
    conditions: [
      "सदर जमिन क्षेत्रावर एकत्रिकृत विकास नियंत्रण व प्रोत्साहन नियमावली, २०२० नुसार विकास परवानगी अनुज्ञेय राहील.",
      "भविष्यात सदर ठिकाणी विकास योजना / प्रादेशिक योजनेचे प्रस्ताव नव्याने नियोजित / प्रस्तावित झाल्यास त्याप्रमाणे भूवापरात बदल होईल.",
    ],
    footer: {
      note: "सदर भाग नकाशा हा प्रकरणासोबत ऑनलाईन स्वरुपात प्राप्त झालेल्या कागदपत्रांचे आधारे देण्यात येत आहे. सदरची कागदपत्रे खोटी तथा दिशाभूल करणारी आढळल्यास सदरचा सदरचा भाग नकाशा आपोआप रह होण्यास पात्र असेल.",
      signature: {
        name: "",
        designation: "शाखा अभियंता",
        office: "सांगली मिरज आणि कुपवाड शहर महानगरपालिका",
      },
      attachment: "सोबत : - भाग नकाशा",
    },
    partPlanPage: {
      title: [`Part Plan Show City Survey No. ${survey} And it's surrounding of ${village}`],
      scaleImage: { src: s1, alt: "Scale", className: styles.scaleImage, height: 30 },
      indexImage: { src: l1, alt: "Index", className: styles.indexImage },
    },
  };

  // Loading / Error States
  if (errorMsg) {
    return (
      <p style={{ textAlign: "center", color: "red", marginTop: "2rem" }}>
        Error: {errorMsg}
      </p>
    );
  }

  if (isLoading) {
    return (
      <>
        <p style={{ textAlign: "center", marginTop: "2rem", fontWeight: "bold" }}>
          कृपया प्रतीक्षा करा... भाग नकाशा तयार होत आहे.
        </p>
        <CroppedMapImage
          village={village}
          survey={survey}
          onImageReady={setCroppedImage}
          onError={(err) => setErrorMsg("भाग नकाशा लोड करण्यात त्रुटी आली.")}
          key={`${village}-${survey}`} // Add key to force re-render when props change
        />
      </>
    );
  }

  // Actual Document Output (unchanged)
  return (
    <>
      {/* First Page - Letter */}
      <div className={styles.letterContainer}>
        <div className={styles.logo}>
          <img
            src={documentData.header.logo}
            alt="Government Logo"
            className={styles.logoImage}
            style={{ height: "70px" }}
          />
        </div>

        <div className={styles.headerText}>
          {documentData.header.govtText.map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </div>

        <div className={styles.contactRow}>
          <div className={styles.email}>{documentData.header.contactInfo.email}</div>
          <div className={styles.phone}>{documentData.header.contactInfo.phone}</div>
        </div>

        <hr className={styles.divider} />

        <div className={styles.refDateRow}>
          <div>{documentData.header.reference.leftText}</div>
          <div>{documentData.header.reference.rightText}</div>
        </div>

        <div className={styles.sectionRecipient}>
          <strong>{documentData.recipient.title}</strong>
          <br />
          <div>
            &nbsp;&nbsp; {documentData.recipient.name}
            <br />
            &nbsp;&nbsp; {documentData.recipient.address}
          </div>
        </div>

        <div className={styles.section}>
          <strong>{documentData.subject.title}</strong> {documentData.subject.text}
          <br />
          <strong>{documentData.reference.title}</strong> {documentData.reference.text}
        </div>

        <div className={styles.bodyText}>
          {documentData.body.salutation}
          <br />
          <div dangerouslySetInnerHTML={{ __html: documentData.body.content }} />
        </div>

        <ol className={styles.conditionList}>
          {documentData.conditions.map((condition, i) => (
            <li key={i}>{condition}</li>
          ))}
        </ol>

        <div className={styles.footer}>
          <p className={styles.footer1}>{documentData.footer.note}</p>
          <div className={styles.signature} style={{ textAlign: "right" }}>
            {signBase64 ? (
              <img
                src={signBase64}
                alt="Signature"
                style={{ maxWidth: "150px", marginBottom: "1px" }}
              />
            ) : (
              <div>No signature uploaded</div>
            )}
            <div>
              {documentData.footer.signature.name}
              <br />
              {documentData.footer.signature.designation}
              <br />
              {documentData.footer.signature.office}
            </div>
          </div>
          <p className={styles.footer3}>
            <strong>{documentData.footer.attachment}</strong>
          </p>
        </div>
      </div>

      {/* Second Page - Part Plan */}
      <div className={styles.letterContainer}>
        <div className={styles.headerText}>
          {documentData.partPlanPage.title.map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </div>

        <div className={styles.scaleicon}>
          <img
            src={documentData.partPlanPage.scaleImage.src}
            alt={documentData.partPlanPage.scaleImage.alt}
            className={documentData.partPlanPage.scaleImage.className}
            style={{ height: `${documentData.partPlanPage.scaleImage.height}px` }}
          />
        </div>

        <div className={styles.mapContainer}>
          <img src={croppedImage} alt="Cropped Map" />
        </div>

        <div className={styles.index}>
          <img
            src={documentData.partPlanPage.indexImage.src}
            alt={documentData.partPlanPage.indexImage.alt}
            className={documentData.partPlanPage.indexImage.className}
          />
        </div>
      </div>
    </>
  );
};

export default DocPartPlan;
